module.exports = __webpack_public_path__ + "img/20240802144719678Hm.ee3e1e01.png";